import { render, staticRenderFns } from "./EffectSummary.vue?vue&type=template&id=653ed631&scoped=true&"
import script from "./EffectSummary.vue?vue&type=script&lang=js&"
export * from "./EffectSummary.vue?vue&type=script&lang=js&"
import style0 from "./EffectSummary.vue?vue&type=style&index=0&id=653ed631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ed631",
  null
  
)

export default component.exports